/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Extractionmodel1Inputs */

const en__field_extractionmodel1 = /** @type {(inputs: _Field_Extractionmodel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction model`)
};

/** @type {(inputs: _Field_Extractionmodel1Inputs) => LocalizedString} */
const de__field_extractionmodel1 = en__field_extractionmodel1;

/**
* | output |
* | --- |
* | "Extraction model" |
*
* @param {_Field_Extractionmodel1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_extractionmodel1 = /** @type {((inputs?: _Field_Extractionmodel1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Extractionmodel1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_extractionmodel1(inputs)
	return de__field_extractionmodel1(inputs)
});
export { _field_extractionmodel1 as "_field_extractionModel" }